import { Component, OnInit, Input, OnDestroy, ViewChild, ComponentFactoryResolver, Output, EventEmitter } from '@angular/core';
import { QuesItem, IQuesComponentInterface } from '../questions/ques.type';
import { QuesDirective } from '../questions/ques.directive';
import { QuesComponentMap, QuestionMap } from '../questions/ques.map';
import { ButtonStyle, ButtonType, ButtonSize, ButtonColors } from '../inputs/button/button.model';
import { trigger, transition, style, animate } from '@angular/animations';
import { ISectionComponentInterface } from './section.type';

@Component({
    selector: 'app-section',
    templateUrl: './section.component.html',
    styleUrls: ['./section.component.scss'],
    animations: [
        trigger('fadeIn', [
            transition(':enter', [
                style({ opacity: '0' }),
                animate('1s ease-in', style({ opacity: '1' })),
            ]),
            transition(':leave', [
                style({ opacity: '1' }),
                animate('2s ease-out', style({ opacity: '0' })),
            ])
        ]),
    ],
    standalone: false
})
export class SectionComponent implements OnInit, OnDestroy, ISectionComponentInterface {
    @Input() quesItems: QuesItem[];
    @Input() data: any;
    @Input() id: string;    
    @Output() deleteSection: EventEmitter<string> = new EventEmitter();

    @ViewChild(QuesDirective, { static: true }) quesHost: QuesDirective;
    // Keep track of list of generated components for removal purposes
    components:QuestionMap[] = [];
    btnPlus = ButtonStyle.PlusIcon;
    btnTextOnly = ButtonStyle.Textonly;
    btnText = "DELETE";
    btnRect = ButtonType.Rectangle;
    btnColor = ButtonColors.Red;
    btnRnd = ButtonType.Round;
    btnMedium = ButtonSize.Medium;
    constructor(private componentFactoryResolver: ComponentFactoryResolver) {        
    }

    ngOnInit() {        
        if (this.quesItems != undefined && this.quesItems.length != 0) {
            //TODO
            //Traverse JSON and inject questions dynamically to DOM and render with data.
        }
        else {
            this.quesItems = QuesComponentMap;
        }
    }
    ngOnDestroy() {
        //This blank function is mandatory.
    }
    loadComponent(componentName: string) {
        const quesItem = this.quesItems.find(x => x.name === componentName);
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(quesItem.component);

        const viewContainerRef = this.quesHost.viewContainerRef;
        //viewContainerRef.clear();

        const componentRef = viewContainerRef.createComponent(componentFactory);
        (<IQuesComponentInterface>componentRef.instance).data = quesItem.data;
        let compId = window.uniqueId();
        (<IQuesComponentInterface>componentRef.instance).id = compId;
        // Push the component so that we can keep track of which components are created
        this.components.push({ Id: compId, ComponentRef: componentRef });
        //Map event handler
        if (!!(<IQuesComponentInterface>componentRef.instance).deleteQuest) {
            // close is eventemitter decorated with @output 
            (<IQuesComponentInterface>componentRef.instance).deleteQuest.subscribe(
                dt=>this.removeComponent(dt));
        }
        
    }
    selectComponent(componentName: string) {
        this.loadComponent(componentName);
    }
    removeComponent(id: string) {
        // Find the component
        const component = this.components.find((component) => component.Id === id);        
        const componentIndex = this.components.indexOf(component);

        const viewContainerRef = this.quesHost.viewContainerRef;
        if (componentIndex !== -1) {
            // Remove component from both view and array
            viewContainerRef.remove(viewContainerRef.indexOf(component.ComponentRef.hostView));
            this.components.splice(componentIndex, 1);
        }
    }
    removeSection(id: any) {
        this.deleteSection.emit(id);
    }
}
